<template>
  <div class="layout hom-layout">
    <lateralNavigation></lateralNavigation>
    <rightNav ></rightNav>
    <div class="haeder_swipe">
      <el-carousel indicator-position="outside" height='556px'>
            <el-carousel-item v-for="(item,index) in getStoreSeckillBySort('1')" :key="index">
              <img :src="item.image" alt="">
            </el-carousel-item>

        <!-- <el-carousel-item >
          <img src="/static/image/banner1.3.jpg" alt="">
        </el-carousel-item> -->
      </el-carousel>
    </div>
        <div class="main">
            <div class="main_fl"><span class="main_bol">热门榜单</span>
                  <router-link class="btn-all" :to="{path:'/categoryProduct',query:{id:2, name:'热门榜单'}}">查看全部<i class="iconfont icon-arrow-right"></i></router-link>
            </div>
           <div class="shopitem">
            <div @click="goToProDetail(item)" class="likeProItem" v-for="item of shopHot" :key="item.id">
              <div class="main_shop1">
                    <div class="main_shop1_ite">
                        <img :src="item.image"  @click="toProductDetail(item)" alt="">
                    </div>
                    <div>
                      <div class="main_datail" :title="item.storeName">{{item.storeName}}</div>
                      <p class="main_price"><span>¥</span>{{item.price}}<span></span>   </p>
                    </div>
                </div>
              </div>
          </div>
        </div>
        <div class="main">
            <div class="main_fl"><span class="main_bol">精品推荐</span>
             <!-- <router-link class="btn-all" :to="{name:'categoryProduct',query:{id:1, name:'精品推荐'}}">查看全部<i class="iconfont icon-arrow-right"></i></router-link> -->
             <router-link class="btn-all" :to="{name:'categoryProduct',query:{id:1, name:'精品推荐'}}">查看全部<i class="iconfont icon-arrow-right"></i></router-link>

              </div>
            <div class="shopitem">
                <div @click="goToProDetail(item)" class="likeProItem" v-for="item of shopRecommend" :key="item.id">
                  <div class="main_shop1">
                      <div class="main_shop1_ite">
                          <img :src="item.image" @click="toProductDetail(item)" alt="">
                      </div>
                      <div>
                        <div class="main_datail" :title="item.storeName">{{item.storeName}}</div>
<!--                            <div class="main_datail" :title="item.storeName">{{item.storeName}}</div>-->
                        <p class="main_price"><span>¥</span>{{item.price}}<span></span>  </p>
                      </div>
                  </div>
                </div>
            </div>
            <div class="main_im">
                <!-- <img src="/static/image/shop03.png" alt=""> -->
                <el-carousel height='249.167px'>
                    <el-carousel-item  v-for="(item,index) in getStoreSeckillBySort('2')" :key="index">
                      <!-- {{item.image}} -->
                      <img :src="item.image" alt="">
                    </el-carousel-item>
                  </el-carousel>
            </div>
        </div>
        <div class="main">
            <div class="main_fl"><span class="main_bol">首发新品</span>
              <router-link class="btn-all" :to="{name:'categoryProduct',query:{id:3, name:'首发新品'}}">查看全部<i class="iconfont icon-arrow-right"></i></router-link>
            </div>
            <div class="shopitem">

                 <div @click="goToProDetail(item)" class="likeProItem" v-for="item of shopNew" :key="item.id">
                  <div class="main_shop1">
                        <div class="main_shop1_ite">
                            <img :src="item.image" @click="toProductDetail(item)" alt="">
                        </div>
                        <div>
                          <div class="main_datail" :title="item.storeName">{{item.storeName}}</div>
                          <p class="main_price"><span>¥</span>{{item.price}}<span></span>   </p>
                        </div>
                    </div>
                  </div>
            </div>
            <div class="main_im">
                <!-- <img src="/static/image/shop03.png" alt=""> -->
                <el-carousel height='249.167px'>
                    <el-carousel-item  v-for="(item,index) in getStoreSeckillBySort('3')" :key="index">
                      <!-- {{item.image}} -->
                      <img :src="item.image" alt="">
                    </el-carousel-item>
                  </el-carousel>
            </div>
        </div>
        <div class="main">
         <div class="main_fl"><span class="main_bol">促销单品</span>
         <router-link class="btn-all" :to="{name:'categoryProduct',query:{id:4, name:'促销单品'}}">查看全部<i class="iconfont icon-arrow-right"></i></router-link>
            </div>
          <div class="main_im">
              <!-- <img src="/static/image/shop04.png" alt=""> -->
              <el-carousel height='249.167px'>
                  <el-carousel-item  v-for="(item,index) in getStoreSeckillBySort('4')" :key="index">
                    <img :src="item.image" alt="">
                  </el-carousel-item>
                </el-carousel>
          </div>
          <div class="shopitem">
               <div @click="goToProDetail(item)" class="likeProItem" v-for="item of shopItem" :key="item.id">
                <div class="main_shop1">
                      <div class="main_shop1_ite">
                          <img :src="item.image" @click="toProductDetail(item)" alt="">
                      </div>
                      <div>
                        <div class="main_datail" :title="item.storeName">{{item.storeName}}</div>
                        <p class="main_price"><span>¥</span>{{item.price}}<span></span> </p>
                      </div>
                  </div>
                </div>
          </div>
        </div>
        <div class="main">
            <div class="main_fl"><span class="main_bol">商品列表</span>
             <router-link class="btn-all" :to="{name:'categoryProduct',query:{id:0, name:'商品列表'}}">查看全部<i class="iconfont icon-arrow-right"></i></router-link>
             <!-- <router-link class="btn-all" :to="categoryProduct">查看全部<i class="iconfont icon-arrow-right"></i></router-link> -->
             </div>
            <div class="main_im">
                <!-- <img src="/static/image/shop04.png" @click="toProductDetail(item)" alt=""> -->
                <el-carousel height='249.167px'>
                    <el-carousel-item  v-for="(item,index) in getStoreSeckillBySort('5')" :key="index">
                      <img :src="item.image" alt="">
                    </el-carousel-item>
                  </el-carousel>
            </div>
            <div class="shopitem">
              <div @click="goToProDetail(item)" class="likeProItem" v-for="item of shopList" :key="item.id">
                <div class="main_shop1">
                  <div class="main_shop1_ite">
                    <img :src="item.image" @click="toProductDetail(item)" alt="">
                  </div>
                  <div>
                    <div class="main_datail" :title="item.storeName">{{item.storeName}}</div>
                      <p class="main_price"><span>¥</span>{{item.price}}<span></span> </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </div>
</template>

<script>
import componentMap from './componentMap'
import lateralNavigation from '../base/lateralNavigation'
import api from '@/api'
import { listSearchMixin } from '@/config/mixin'
import { mapMutations } from 'vuex'
import rightNav from './rightNav'
export default {
  name: 'canvasPage',
  components: {rightNav,lateralNavigation},
  mixins: [listSearchMixin],

  data () {
    return {
      viewDevice: 4,
      componentsData: [],
      activeComponent: -1,
      componentMap: componentMap,
      sstt: [
        'itemMenu1',
        'itemMenu2',
        'itemMenu3',
        'itemMenu4',
        'itemMenu5',
        'itemMenu6',
        'itemMenu7',
        'itemMenu8',
        'itemMenu9',
        'itemMenu10',
        'itemMenu11',
        'itemMenu12'
      ],
      isshow: 10,
      caidan: [
        {cont: 1, name: '图文广告'},
        {cont: 2, name: '电脑'},
        {cont: 3, name: '图文广告'},
        {cont: 4, name: '电脑'},
        {cont: 5, name: '图文广告'},
        {cont: 6, name: '电脑'},
        {cont: 7, name: '图文广告'},
        {cont: 8, name: '电脑'},
        {cont: 9, name: '图文广告'},
        {cont: 10, name: '电脑'}
      ],
      shopRecommend: null, // 精品推荐
      shopHot: null, // 热门榜单
      shopNew: null, // 首发新品
      shopItem: null, // 促销单品
      shopList: null, // 商品列表
      couponsList: null, // 优惠券
      categoryMenu: null, // 左侧菜单
      search_text: '',
      storeSeckills: [], // 商品秒杀产品列表(轮播图)
      hideTypeStatus: true
    };
  },
  mounted() {
    this.canvasGet()
    // 获取商品秒杀轮播图
    this.getStoreSeckill()
  },
  methods: {
    goByPt () {
        this.$router.push({
          path: '/categoryProduct', query: {id: 1, name: '精品推荐'}
        })
    },
    goByqg () {
      this.$router.push({
        path: '/categoryProduct', query: {id: 2, name: '热门榜单'}
      })
    },
    goByjz() {
      this.$router.push({
        path: '/categoryProduct', query: {id: 3, name: '首发新品'}
      })
    },
    goByms () {
      this.$router.push({
        path: '/categoryProduct', query: {id: 4, name: '促销单品'}
      })
    },
    goSiteConfig (type) {
      this.$router.push({path: '/about', query: {type}})
    },
    // 隐藏分类
    hideType () {
      if (this.hideTypeStatus) {
        this.hideTypeStatus = false
      } else {
        this.hideTypeStatus = true
      }
    },
    goProduct (id, name) {
      // :to="{path:'/categoryProduct',query:{id:2, name:'热门榜单'}}"
      this.$router.push({
        path: '/categoryProduct',
        query: {
          id: id,
          name: name
        }
      })
    },
    ...mapMutations({
      setComponentsData: 'SET_COMPONENTSDATA',
       setCurrentPro: 'SET_CURRENTPRO',
       show (cont) {
          this.isshow = cont
        }
    }),
    search () {
          // let paramsMenu = {
          //       url: api.getSearchProducts+"/"+this.search_text,
          //       method: "GET",
          //     };
          //     this.sendReq(paramsMenu, (res) => {
          //       console.log(res);
          //     });

        this.$router.push({
                  path: '/search', query: {keyword: this.search_text}
        })
    },

    // 读取画布
    canvasGet () {
      let _this = this
      let componentsData = []
      // 左侧菜单获值
      let paramsMenu = {
        url: api.getCanvasMenu,
        method: 'GET'
      }
      this.sendReq(paramsMenu, (res) => {
        this.categoryMenu = res.data
      });
      // 首页楼层数据;
      let params = {
      url: api.getlistByFirst,
      method: 'get',
      data: {
      }
    }
      this.sendReq(params, (res) => {
        if (res.success) {
          // console.log("-------",res.data)
          this.shopHot = res.data.shopHot
          this.shopItem = res.data.shopItem
          this.shopList = res.data.shopList
          this.shopNew = res.data.shopNew
          this.shopRecommend = res.data.shopRecommend
        }
      })

      // 获取优惠券
      this.sendReq(
        {
          url: `${api.getCouponsList}`,
          method: 'GET'
        },
        (proRes) => {
          if (proRes.status === 200) {
              // console.log("---",proRes.data);
            this.couponsList = proRes.data
          }
        }
      );
    },
    toProductDetail (item) {
      console.log(item)
      this.setCurrentPro(item)
      this.$router.push({path: '/productDetail?productId=' + item.storeCode})
    },
    // 获取轮播图
    getStoreSeckill () {
      this.sendReq(
        {
          url: `${api.selectBannerList}`,
          method: 'GET'
        },
        (proRes) => {
          if (proRes.status === 200) {
            this.storeSeckills = proRes.data
          }
        }
      )
    },
    // 获取对应类型的轮播图
    getStoreSeckillBySort (type) {
      var endData = []
      var data = []
      if (type) {
        data = this.storeSeckills.filter(item => {
          return item.type == type
        })
        data.map(item => {
          item.map.imageArr.map(item => {
            endData.push({
              'image': item
            })
          })
        })
      }
      return endData
    }
  },
};
</script>

<style lang="scss" scoped>
.lists ul li:hover {
  color: #fff;
  background-color: #fe550c;
}
.hom-layout {
  //background-color: #f3f5f6;
}
.warp {
  width: 1252px;
  margin: 0 auto;
  max-width: 96%;
}
.flex-box {
  display: flex;
}
.originalPrice {
  font-size: 16px;
  text-decoration: line-through;
  margin-left: 10px;
}

.right_icon{
  margin-left: 5px;
}
.classsop{
  background-color: #FE550C;
  width: 208px;
  height: 56px;
  text-align: center;
  margin-left: -90px;
  font-size: 28px;
  color: #fff;
  line-height: 52px;
}
.caidan_i{
  margin-right: 20px;
  float: right;
}
.caidan>ul>li>ul>li{
  margin-left: 60px;
}
.caidan>ul>li>ul{
  list-style: none;
  margin-left: 20px;
}
.caidan>ul>li{
  margin-top: 20px;
}
.caidan>ul{
/* background-color: #606266; */
  list-style: none;
  /* text-align: center; */
  color: #fff;
  margin-top: 40px;
}
.caidan{
  //background-color: #000;
  width: 208px;
  height: 556px;
  position: absolute;
  z-index: 777;
  margin-left: 26px;
  background-color: rgba(240,240,240,0.9);
}
.caidan_div{
  margin-left: 54px;
  margin-right: 20px;
}
.main_shop1_ite img{
  width: 100%;
  transition: transform 1.6s;
  margin-top: 0;
}
.main_youhui img{
  width: 100%;
}
.main_youhui{
  width: 360px;
  height: 127px;
  /* border: 1px solid red; */
  margin-top: 41px;
}
.main_im{
  margin-top: 80px;
}
.main_im img{
  width: 100%;
}
.shopitem{
  display: flex;
  // justify-content: space-around;

}
.main_price span{
  line-height: 12px;
  font-size: 8px;
  font-weight: normal;
}
.main_price{
  font-size: 14px;
  font-weight: bold;
  color: $mainColor;
  margin-left: 28px;
  /* display: flex; */
  /* align-items: flex-end;  */
  line-height: 24px;
}
.main_datail{
  font-family: Microsoft YaHei;
  margin-top: 15px;
  margin-bottom: 10px;
  font-weight: 400;
  width: 176px;
  height: 45px;
  line-height: 24px;
  margin-left: 28px;
  font-size: 14px;
  color: #666666;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.main_shop1_ite{
  width: 190px;
  height: 190px;
  margin: 0 auto;
  transition: transform 0.6s;
  cursor: pointer;
  overflow: hidden;
  // overflow: hidden;
}
.main_shop1_ite img{
    width: 100%;
}
.shopitem{
  flex-wrap: wrap;
  border-top: 1px solid #F1F3F5;
}
.main_shop1{
  width: 230px;
  height: 320px;
  /* border: 1px solid red; */
  margin-top: 41px;
  // padding: 17px 20px 0 20px;
  padding-left: 0%;

  border: 1px solid #eeeeee;
}
.main_imgtop img{
  margin-top: -20px;
}
.main_sm{
  width: 96px;
  font-size: 18px;
  color: #666666;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main_fl{
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.main_bol{
  font-weight: bold;
  font-size: 30px;
}
.main{
  width:1250px;
  // margin-top: 80px;
  margin: 0 auto;
  margin-top: 25px;
}
.el-carousel__item,.el-carousel__item img {
  line-height: 556px;
  margin: 0;
  height: 556px;
}
.haeder_swipe{
  width: 100%;
  margin-top: 20px;
  height: 556px;
}
.header_xuanul {
  display: flex;
  justify-content: center;
  line-height: 52px;
  font-family: PingFang SC;
  font-weight: 500;
}
.header_xuanul li{
  list-style: none;
  margin-left: 20px;
  font-size: 28px;
  margin-left: 34px;
}
.header_b{
  display: flex;
  justify-content: space-between;
  position: relative;
}
.el-icon-search{
  position: absolute;
  margin-top: 33px;
  margin-left: 16px;
}
.header_btn{
  background: #D22929;
  border:none;
  height: 42px;
  line-height: 42px;
  padding: 0px 15px;
  outline:none;
  color:white;
  margin-left: -5px;
  border-radius: 0 4px 4px 0;
}
.header_input{
  text-indent: 50px;
  outline:none;
  border: 1px solid #D22929;
  color: #606266;
  height: 40px;
  line-height: 40px;
  padding: 0px 15px;
  width: 370px;
  margin-top: 20px;
  border-radius: 4px 0 0 4px;
}
.right_ul{
  display: flex;
  align-content: center;
  margin-right: 120px;
}
.right_ul li{
  list-style: none;
  padding: 0 15px;
}
.left{
  float: left;
  /* box-sizing: inherit; */
  margin-left: 25px;
}
.right{
  float: right;
  margin-right: -13px;
}
.header_left{
  margin-right: 5px;
}
.header_iocn{
  margin-left: 5px;
  color: #ec7b18;
}
.header_img{
  margin-left: 20px;
}
.header,.header_b{
  height: 82px;
  //background-color: #F1F2F7;
  line-height: 42px;
  font-size: 14px;
}
.conte{
   width: 1250px;
   margin: 0 auto;
}

.conte1 .header_xuan{
  //width: 1250px;
  margin: 0 auto;
  position: relative;
  left: 300px;
}

.classification{
  height: 470px;
  color: #000;
  position: relative;
  ul{
    li{
      line-height: 42px;
      .item{
        cursor: pointer;
        font-size: 14px;
        padding:0 20px 0 30px;
      }
      .icon{
        float: right;
        line-height: 42px;
      }
      .hoverBox{
        position: absolute;
        width: 1000px;
        padding:10px 25px;
        height: 1000px;
        left: 100%;
        top: 0;
        z-index: 3;
        display: none;
        background-color: #FFFFFF;
        color: #333;
        //border: 2px solid $mainColor;
        overflow-x: hidden;
        // overflow: scroll-y;
        .over{
          width: 1000px;
          padding:10px;
          height: 800px;
        }
        dl{
          margin-bottom: 5px;
          dt{
            height: 34px;
            line-height: 34px;
            font-size: 16px;
            color: #333;
            font-weight: bold;
            border-bottom: 1px dashed rgba(200,200,200,0.5);
          }
          dd{
            line-height: 26px;
            font-size: 12px;
            margin-left: 0;
            a{
              margin-right: 12px;
              &:hover{
                color: $mainColor;
              }
            }
          }
        }
      }
      &:hover{
        color: $mainColor;
        .hoverBox{
          display: block;
        }
      }
    }
  }
}

  .likeProItem{
    padding: 15px 8.5px;
    //background-color: white;
  }
  .main_shop1{
    margin-top: 0;
    background-color: #FFFFFF;
    padding: 10px 0px;
  }
  .main_shop1:hover {
    transform: scale(1.05);
    //box-shadow: 1px 1px 1px #D22929;
    border: 1px solid #006865;
  }
  .caidan{
    margin-left: 0;
  }
  .main_shop1_ite:hover{
    //transform: scale(1.1);
  }
  .main_im{
    margin-top: 50px;
  }
  .shopitem{
    // margin-top: 35px;
  }
  // .main{
  //   margin-top: 50px;
  // }
  .main_im{
    margin-top: 0;
  }
  .three{
    width: 500px;
    height: 40px;
    line-height: 40px;
    z-index: 4;
  }
  .three-in{
     height: 40px;
     line-height: 40px;
     display: inline-block;
     font-size: 18px;
     margin-right: 10px;
  }
  .four{
    font-size: 12px;
    width: 80px;
    height: 40px;
    line-height: 40px;
    display: inline-block;
    margin-right: 12px;
   }
  .four-in{
    width: 120px;
    height: 40px;
    display: inline-block;
  }
  .header_img[data-v-85b972c4] {
    height: 50px;
    margin-left: 0px;
 }
 .header_img img{
   width: 252px;
   height: 83px;
 }
 .lists{
   border: 1px solid red;
   width: 100%;
   height: 35px;
   position: absolute;
   z-index: 5;
   top:133px;
   background-color: #D22929;
   display: flex;
 }
 .lists h3{
   width: 208px;
   height: 35px;
   display: block;
   line-height: 30px;
   text-align: left;
   font-weight: 500;
   font-size: 18px;
   color: white;
   background-color: #000000;
   //padding-left: 14.5%
   i {
     height: 17px;
     width: 19px;
     background-image: url(../../../static/image/menu-til.png);
     float: left;
     margin-top: 9px;
     margin-left: 10px;
     margin-right: 10px;
   }
 }
  .lists ul{
     width: 1000px;
     height: 35px;
     display: flex;
     list-style-type: none;
     color: white;
  }
 .lists li{
   width: 100px;
   height: 35px;
   text-align: center;
   line-height: 30px;
   display: block;
   float: left;
   margin-right: 1px;
   font-size: 16px;
   font-weight: 500px
 }
 .one{
   margin-left: 20px;
 }

  .el-carousel{
    position: relative;
  }
 .el-carousel__container{
   width: 100%;
   margin: auto;
   position: absolute;
 }
 .el-carousel__item .is-animating{
   margin: 0 auto;
 }
 .el-carousel__item img{
  //  width: 100%;
   width: 100%;
   display: block;
   margin: auto;
 }

 /* 针对下方子轮播图 */
 .main_im .el-carousel__item,.main_im .el-carousel__item img {
    line-height: 249.167px;
    margin: 0;
    height: 249.167px;
  }
  .main_im .el-carousel__item img{
    width: 100%;
  }
.itemMenu1 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px 0px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}

.itemMenu2 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -30px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu3 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -60px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu4 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -90px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu5 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -120px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu6 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -150px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu7 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -180px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu8 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -210px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu9 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -240px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}

.itemMenu10 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -270px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}

.itemMenu11 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -300px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}

.itemMenu12 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -330px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/canvasShow/canvasShowPage.vue